import { useNavigate } from 'react-router-dom';
import { PageContainer } from '@/components/layout/PageContainer';

export function FindAccountPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleFindId = () => {
    navigate('/find-id');
  };

  const handleResetPassword = () => {
    navigate('/reset-password');
  };

  return (
    <div className="min-h-screen bg-white">
      <PageContainer>
        {/* 헤더 */}
        <div className="flex items-center justify-center relative mb-20">
          <button
            onClick={handleBack}
            className="absolute left-0 p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <img
              src="/icons/icon_back.svg"
              alt="뒤로가기"
              className="w-6 h-6"
            />
          </button>
          <h1 className="text-2xl font-bold text-[#222222]">계정정보 찾기</h1>
        </div>

        {/* 메인 콘텐츠 */}
        <div className="max-w-[360px] mx-auto space-y-32 mt-40">
          {/* 아이디 찾기 버튼 */}
          <button
            onClick={handleFindId}
            className="w-full h-[60px] bg-[#DEDEDE] text-[#222222] font-bold text-2xl rounded-xl hover:bg-[#CECECE] transition-colors"
          >
            아이디 찾기
          </button>

          {/* 비밀번호 재설정 버튼 */}
          <button
            onClick={handleResetPassword}
            className="w-full h-[60px] bg-[#DEDEDE] text-[#222222] font-bold text-2xl rounded-xl hover:bg-[#CECECE] transition-colors"
          >
            비밀번호 재설정
          </button>
        </div>
      </PageContainer>
    </div>
  );
}